<template>
    <section class="add-contact">
        <section class="add-contact-form">
            <button class="add-contact-form__exit-btn" @click="(e) => handler(e, 'none')">
                <img src="../../../../../../assets/icons/components/exit-btn.svg" />
            </button>
            <section class="add-contact-form__form-wrapper">
                <section class="add-contact__header">
                    <section class="add-contact-form__title">  {{ isEdit ? $t('com.global.edit') : $t('com.global.add') }} {{$t('com.file.add-contact.contact')}} </section>
                    <section class="import-from-db">
                        <ButtonWithIconContacts v-if="isEdit && phoneNumber.length > 0" icon="send-sms" text="SMS" @click="openSendSMSModal()" />
                        <ButtonWithIconContacts v-if="isEdit && mail.length > 0" icon="send-mail" text="e-mail" @click="openSendEmailModal()" />
                        <ButtonWithIconContacts v-if="isEdit && adminMainPrivilige" icon="lock" :text="$t('com.file.add-contact.priviliges')" @click="openPriviligesModal()" />
                    </section>
                </section>
                <section class="add-contact__body">
                    <section class="add-contact-form__inputs">
                        <section class="add-contact-form__header">
                            <h3 class="add-contact-form__title add-contact-form__title--small">
                                {{$t('com.file.add-contact.contact-data')}} <span v-if="storedUserEditData.id != null" style="font-size: 12px; font-weight: 400;">(ID: {{storedUserEditData.id}})</span>
                            </h3>
                        </section>
                        <section class="add-contact-form__body">
                            <section class="add-contact-form__row">
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.import-concatc-summary.name')}}</label>
                                    <input type="text"
                                           v-model="firstName"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'first_name' }" />
                                    <ErrorMessage v-if="isError('first_name', this.errors)"
                                                  :errorMsgs="
                                    passErrorMsg('first_name', this.errors)
                                " />
                                </section>
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.import-concatc-summary.last-name')}}</label>
                                    <input type="text"
                                           v-model="lastName"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'last_name' }" />
                                    <ErrorMessage v-if="isError('last_name', this.errors)"
                                                  :errorMsgs="
                                    passErrorMsg('last_name', this.errors)
                                " />
                                </section>
                            </section>
                            <section class="add-contact-form__row">
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.announcements.title')}}</label>
                                    <input type="text"
                                           v-model="title"
                                           class="add-contact-form__input-text" />

                                </section>
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.add-contact.contact-function')}}</label>
                                    <input type="text"
                                           v-model="role"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'role' }" />
                                    <ErrorMessage v-if="isError('role', this.errors)" :errorMsgs="passErrorMsg('role', this.errors)" />

                                </section>
                            </section>
                            <section class="add-contact-form__row">
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.add-contact.contact-phone')}}</label>
                                    <input v-model="phoneNumber"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'phone_number' }" />
                                    <ErrorMessage v-if="isError('phone_number', this.errors)"
                                                  :errorMsgs="
                                    passErrorMsg('phone_number', this.errors)
                                " />
                                </section>
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">Fax</label>
                                    <input type="mail"
                                           v-model="fax"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'fax' }" />
                                    <ErrorMessage v-if="isError('fax', this.errors)"
                                                  :errorMsgs="passErrorMsg('fax', this.errors)" />
                                </section>
                            </section>
                            <section class="add-contact-form__row-single">
                                <section class="add-contact-form__col-single">
                                    <label class="add-contact-form__label">{{$t('com.file.import-concatc-summary.email')}}</label>
                                    <input type="mail"
                                           v-model="mail"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'email' }" />
                                    <ErrorMessage v-if="isError('email', this.errors)"
                                                  :errorMsgs="passErrorMsg('email', this.errors)" />
                                </section>

                            </section>
                            <section class="add-contact-form__row-single">
                                <section class="add-contact-form__col-single">
                                    <label class="add-contact-form__label">{{$t('com.file.add-contact.contact-address')}}</label>
                                    <input type="text"
                                           v-model="street"
                                           class="add-contact-form__input-text" />

                                </section>

                            </section>
                            <section class="add-contact-form__row">
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.add-contact.contact-city')}}</label>
                                    <input type="text"
                                           v-model="city"
                                           class="add-contact-form__input-text" />

                                </section>
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.add-contact.contact-post-code')}}</label>
                                    <input type="text"
                                           v-model="postal"
                                           class="add-contact-form__input-text" />

                                </section>
                            </section>
                            <section class="add-contact-form__row" v-if="storedUserEditData.isInUserTable && adminNfcModule">
                                <section class="add-contact-form__col">
                                    <label class="add-contact-form__label">{{$t('com.file.add-contact.nfc')}}</label>
                                    <input v-model="nfc" v-tooltip="$t('com.nfc-assigment-modal.valid-nfc-tooltip')"
                                           class="add-contact-form__input-text"
                                           v-error="{ errors, input_key: 'nfc' }" />
                                    <CharactersCounter :text="nfc" :maxLenght="8" />
                                    <ErrorMessage v-if="isError('nfc', this.errors)"
                                                  :errorMsgs="passErrorMsg('nfc', this.errors)" />
                                </section>
                            </section>
                        </section>
                    </section>
                    <section class="add-contact-form__groups">
                        <section class="add-contact-form__header">
                            <h3 class="add-contact-form__title add-contact-form__title--small">
                                {{$t('com.file.add-contact.contact-group-member')}}
                            </h3>
                        </section>
                        <section class="add-contact-form__body">
                            <ErrorMessage v-if="isError('group_ids', this.errors)"
                                          :errorMsgs="passErrorMsg('group_ids', this.errors)" />
                            <section v-for="group in avaliableGroups"
                                     :key="group.id"
                                     class="add-contact-form__checkbox">
                                <CheckBoxButton :id="group.id"
                                                :value="group.id"
                                                @setGroupId="(value)=>(this.checkedGroupsId = value)"
                                                :idsArray="checkedGroupsId"
                                                :checked="checkedGroupsId.indexOf(group.id) !== -1 " />
                                    <label class="add-contact-form__label add-contact-form__label--checkbox" :for="group.id">{{ group.name }}</label>
                            </section>
                        </section>
                        
                    </section>
                </section>
                <section class="add-contact-form__bottom-btns">
                    <button class="add-contact-form__action-btn add-contact-form__action-btn--red" v-if="!saveDisabled" @click="async (e) => await handleAddContactClick(e)">
                        {{$t('com.file.add-contact.save-contact')}}
                    </button>
                    <button class="add-contact-form__action-btn add-contact-form__action-btn" v-else :disabled="saveDisabled" v-tooltip="$t('com.file.add-contact.contact-form-error')">
                        {{$t('com.file.add-contact.save-contact')}}
                    </button>
                    <button class="add-contact-form__action-btn" @click="(e) => handler(e, 'none')"> {{$t('com.global.cancel')}} </button>

                </section>
            </section>
            <SMSModal v-if="showSMSModal" @close="closeSMSModal" :options="smsOptions" :selected="selected" />
            <EmailModal v-if="showEmailModal" @closeEmail="closeEmailModal" :options="emailOptions" :selected="selectedEmail" />
            <PermissionModal v-if="showPermissionModal && adminMainPrivilige" @closePermission="closePermissionModal" :permission="permission" :lid="tempLid" />
        </section>
    </section>
</template>

<script charset="utf-8">
    import CheckBoxButton from "../../../../../BasicControls/CheckBoxButton.vue";
    import ContactService from "../../../../../../services/contact.service";
    import ErrorMessage from "../../../../../BasicControls/ErrorMessage.vue";
    import ButtonWithIconContacts from "../../../../../BasicControls/ButtonWithIconContacts.vue";
    import { encryptStorage } from '../../../../../../services/encrypt.service';
    import SMSModal from "../../../Home/Modals/SendSMS.vue";
    import EmailModal from "../../../Home/Modals/SendEmail.vue";
    import PermissionModal from "../../Modals/AddContact/AddPermission.vue";
    import AlertHelper from '@/helpers/alerts.helper.js';
    import CharactersCounter from "../../../../../BasicControls/CharactersCounter.vue";
    import { debounce, isNfcIsValid } from "../../../../../../helpers/utils";
    import {
        passErrorMsg,
        isError,
        setErrors,
    } from "../../../../../../formValidation/main";

    export default {
        name: "AddContact",
        data() {
            return {
                permission: {},
                smsOptions: [],
                selected: [],
                emailOptions: [],
                selectedEmail: [],
                tempLid: 0,
                showSMSModal: false,
                showEmailModal: false,
                showPermissionModal: false,
                adminMainPrivilige: encryptStorage.getItem("priv").uprawnienia,
                adminNfcModule: encryptStorage.getItem("modules").nfc,
                firstName: "",
                lastName: "",
                title: "",
                role: "",
                phoneNumber: "",
                fax: "",
                mail: "",
                street: "",
                houseNumber: "",
                localNumber: "",
                city: "",
                postal: "",
                nfc: "",
                checkedGroupsId: [],
                isEdit: false,

                city_error: {
                    status: false,
                    msg: "",
                },
                errors: [],
                validateErrors: {},
                liveValidation: {
                    email: true,
                }
            };
        },
        components: {
            CheckBoxButton,
            ErrorMessage,
            ButtonWithIconContacts,
            SMSModal,
            EmailModal,
            PermissionModal,
            CharactersCounter
        },
        props: {
            groups: Array,
            handler: Function,
            storedGroupId: Number,
            storedUserEditData: Object, 
        },
        watch:{
            mail: debounce( async function(){
                let err = { ...this.validateErrors };
                if(this.mail.length < 3){
                    delete err.email;
                    this.errors = setErrors(err)
                    this.validateErrors = {...err};
                    return;
                }

                this.errors = this.errors.filter(item => item?.key !== "email");
                let bo = true;

                const message = await this.validateEmail(this.mail);
                if(message != ""){
                    bo = false;
                    err.email = [message];
                }
                this.liveValidation.email = bo;
                if(!bo){
                    this.errors = setErrors(err)
                }
                else{
                    delete err.email;
                }
                this.validateErrors = {...err};                
            }, 350)
        },
        computed: {
            avaliableGroups() {
                let copy = [...this.groups]
                return copy.sort((group) => {
                    if (this.checkedGroupsId.indexOf(group.id) === -1) {
                        return 1;
                    }
                    return -1;
                })
            },
            saveDisabled(){
                return !this.liveValidation.email;
            }
        },
        mounted() {
            if (this.storedGroupId !== null) {
                this.checkedGroupsId.push(this.storedGroupId);
            }
            if (Object.keys(this.storedUserEditData).length > 0) {
                const {
                    first_name,
                    last_name,
                    role,
                    phone_number,
                    fax,
                    email,
                    street,
                    postal,
                    city,
                    title,
                    groups,
                    nfc
                } = this.storedUserEditData;

                this.title = title;
                this.firstName = first_name;
                this.lastName = last_name;
                this.role = role;
                this.phoneNumber = phone_number;
                this.fax = fax;
                this.mail = email;
                this.street = street;
                this.postal = postal;
                this.city = city;
                this.nfc = nfc;
                this.checkedGroupsId = groups;
                this.isEdit = true;
            }
        },
        methods: {
            async validateEmail(email){
                try{
                    if(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email) == false){
                        throw new Error(this.$t('com.validation-errors.invalid-email-format'));
                    }

                    if (this.isEdit && this.storedUserEditData.id != undefined && this.storedUserEditData.id != null) {

                        await ContactService.validatePerson({personId: this.storedUserEditData.id, field: "email", value: email});
                    }

                    return ""
                }
                catch(e){
                    if(e.response){
                        switch(e.response.status){
                            case 422: return this.$t('com.validation-errors.email-is-already-taken');
                        }
                    }
                    else{
                        return e.message;
                    }
                }
            },
            async validate(data) {

                var bo = true;
                var err = { ...this.validateErrors};
                if (data.first_name == null || data.first_name.length <= 0) {
                    err.first_name = [this.$t('com.global.required-field')]
                    bo = false
                }
                else{
                    delete err.first_name;
                }

                if (data.last_name == null || data.last_name.length <= 0) {
                    err.last_name = [this.$t('com.global.required-field')]
                    bo = false
                }
                else{
                    delete err.last_name;
                }

                if (data.email.length > 0) {
                    
                    const message = await this.validateEmail(data.email);
                    if(message != ""){
                        bo = false;
                        err.email = [message];
                    }
                    else{
                        delete err.email;
                    }
                }
                else{
                    delete err.email;
                }

                if (data.phone_number.length > 0) {
                    if (/^[0-9]+$/.test(data.phone_number) == false) {
                        err.phone_number = [this.$t('com.validation-errors.invalid-phone-format')]
                        bo = false
                    }
                    else{
                        delete err.phone_number;
                    }
                }
                else{
                    delete err.phone_number;
                }

                if (data.fax.length > 0) {
                    if (/^[0-9]+$/.test(data.fax) == false) {
                        err.fax = ['Niepoprawny format fax (tylko cyfry)']
                        bo = false
                    }
                    else{
                        delete err.fax;
                    }
                }
                else{
                    delete err.fax;
                }
                
                if (data.role.length > 0) {
                    if (data.role.length > 150) {
                        err.role = [this.$t('com.validation-errors.char-limit-150')]
                        bo = false
                    }
                    else{
                        delete err.role;
                    }
                }
                else{
                    delete err.role;
                }

                if (Object.keys(data.group_ids).length <= 0) {
                    err.group_ids = [this.$t('com.validation-errors.select-groups')]
                    bo = false
                }
                else{
                    delete err.group_ids;
                }

                if(this.storedUserEditData.isInUserTable && this.adminNfcModule){
                    if(!this.isNfcIsValid(data.nfc)){
                        err.nfc = [this.$t('com.validation-errors.invalid-nfc-code')]
                        bo = false
                    }
                }
                this.validateErrors = {...err};
                if (!bo) {
                    this.$store.state.userStore.isLoading = false;
                    this.errors = setErrors(err)
                }
                return bo
            },
            async handleAddContactClick(e) {
                e.preventDefault();
                this.errors = [];

                this.$store.state.userStore.isLoading = true;

                const data = {
                    first_name: this.firstName?.trim() ?? "",
                    last_name: this.lastName?.trim() ?? "",
                    role: this.role,
                    phone_number: this.phoneNumber,
                    fax: this.fax,
                    email: this.mail,
                    street: this.street,
                    postal: this.postal,
                    city: this.city,
                    title: this.title,
                    group_ids: this.checkedGroupsId,
                    nfc: this.nfc
                };

                if ((await this.validate(data)) == false)
                    return

                if (Object.keys(this.storedUserEditData).length > 0) {

                    ContactService.updateContact(this.storedUserEditData.id, data)
                        .then((r) => {

                            if (r.status !== 200) {
                                if (r.status === 422) {
                                    var t = this.$swal.mixin(AlertHelper.errorToastElement());
                                    t.fire(AlertHelper.errorToastAlert(this.$t('com.validation-errors.invalid-email-or-taken'), this.$t('com.global.error')));
                                }
                                this.$store.state.userStore.isLoading = false;
                            }
                            else {
                                this.reloadContacts();
                            }
                        
                        })
                        .catch((err) => {
                            this.$store.state.userStore.isLoading = false;

                            if (err.response.status === 422) {
                                var t = this.$swal.mixin(AlertHelper.errorToastElement());
                                t.fire(AlertHelper.errorToastAlert(this.$t('com.validation-errors.invalid-email-or-taken'), this.$t('com.global.error')));
                            }
                            else {
                                this.errors = setErrors(err);
                            }
                        });
                } else {
                    ContactService.checkContactExist(data).then((res) => {
                        if (res.status === 200) {
                            if (res.data != null && res.data.length > 0) {

                                const actionToFire = () => {

                                    if (this.$store.state.appStore.selectedButtonActionId == 1) {
                                        // create new contact
                                        this.createContact(data);
                                    }
                                    else if (this.$store.state.appStore.selectedButtonActionId == 2) {
                                        // open edit selected user modal
                                        this.handler(null, "none");
                                        this.handler(null, 'add-contact', { id: res.data[0].id, action: 'edit-contact', });
                                        this.$store.state.userStore.isLoading = false;
                                    }
                                    else {
                                        // wrong id
                                        this.$store.state.userStore.isLoading = false;
                                    }  

                                    this.$store.state.appStore.selectedButtonActionId = 0;
                                };

                                var alertData = {
                                    mainText: this.createInformationToAlert(res.data),
                                   
                                };

                                if (res.data.length > 1) {
                                    alertData.buttons = [
                                        {
                                            id: 1,
                                            text: this.$t('com.file.add-contact.create-new-contact'),
                                            color: '#d80418'
                                        },
                                    ];
                                }
                                else {
                                    alertData.buttons = [
                                        {
                                            id: 1,
                                            text: this.$t('com.file.add-contact.create-new-contact'),
                                            color: '#d80418'
                                        },
                                        {
                                            id: 2,
                                            text: this.$t('com.file.add-contact.edit-find-user-account'),
                                            color: '#122fa3'
                                        },
                                    ];
                                }

                                this.$store.commit("setAlertData", alertData);
                                this.$store.commit("showConfirmationAlertWithData", actionToFire);
                            }
                            else {
                                this.createContact(data);
                            }
                        }
                        else {
                            this.$store.state.userStore.isLoading = false;
                            this.errors = setErrors(res.data);
                        }
                    }).catch((err) => {
                        this.$store.state.userStore.isLoading = false;
                        this.errors = setErrors(err);
                    });
                }
            },
            createInformationToAlert(data) {
                var info = '';
                for (var i = 0; i < data.length; i++) {

                    info += "<p>" + this.$t('com.file.logs.user') + " (<b>" + data[i].first_name + " " + data[i].last_name + "</b>) " + this.$t('com.file.add-contact.same-user-already-exist-info') +"</p>";
                    info += "<p>" + this.$t('com.file.add-contact.in-groups') +":</p>";

                    for (var j = 0; j < data[i].groups.length; j++) {
                        info += "<p>- " + data[i].groups[j].name + "</p>";
                    }

                    info += "<br>"
                }

                info += "<p>" + this.$t('com.file.add-contact.same-user-alert-info-1') +"</p>";
                info += "<p>" + this.$t('com.file.add-contact.same-user-alert-info-2') +"</p>";
                info += "<p>" + this.$t('com.file.add-contact.same-user-alert-info-3') +"</p>";

                return info;
            },
            createContact(data) {
                ContactService.createContact(data)
                    .then(() => {
                        this.reloadContacts();
                    })
                    .catch((err) => {
                        this.$store.state.userStore.isLoading = false;
                        this.errors = setErrors(err);
                    });
            },
            reloadContacts() {
                ContactService.show(false).then((response) => {
                    this.$emit("renewGroups", response.data);
                    this.firstName = "";
                    this.lastName = "";
                    this.title = "";
                    this.role = "";
                    this.phoneNumber = "";
                    this.fax = "";
                    this.mail = "";
                    this.street = "";
                    this.houseNumber = "";
                    this.localNumber = "";
                    this.city = "";
                    this.postal = "";
                    this.checkedGroupsId = [];
                    this.handler(null, "none");
                    this.$store.state.userStore.isLoading = false;
                });
            },
            async openSendSMSModal() {
                try {
                    var result = (await ContactService.getUsersToSmsOrEmail(1)).data;
                    if (Object.keys(result).length > 0) {
                        this.selected = [];
                        this.selected.push(this.storedUserEditData.id);
                        this.smsOptions = result;
                        this.showSMSModal = true;
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            async openSendEmailModal() {
                try {
                    var result = (await ContactService.getUsersToSmsOrEmail(2)).data;
                    if (Object.keys(result).length > 0) {
                        this.selectedEmail = [];
                        this.selectedEmail.push(this.storedUserEditData.id);
                        this.emailOptions = result;
                        this.showEmailModal = true;
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            async openPriviligesModal() {
                try {
                    var result = (await ContactService.getUserDataToEdit(this.storedUserEditData.id)).data;
                    if (Object.keys(result).length > 0) {
                        this.permission = result;
                        this.tempLid = this.storedUserEditData.id;
                        this.showPermissionModal = true;
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            closeSMSModal() {
                this.showSMSModal = false;
                this.smsOptions = [];
                this.selected = [];
            },
            closeEmailModal() {
                this.showEmailModal = false;
                this.emailOptions = [];
                this.selectedEmail = [];
            },
            closePermissionModal() {
                this.showPermissionModal = false;
                this.permission = {};
                this.tempLid = 0;
            },
            passErrorMsg,
            setErrors,
            isError,
            isNfcIsValid
        },
    };
</script>

<style lang="scss" scoped>
    .add-contact {
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 10;
        background: #00082c75;
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #dde0e7;
            padding: 15px 0;
        }

        &__body {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            column-gap: 20px;
        }
    }


    .add-contact-form {
        background: linear-gradient(146.23deg, #f4f8ff 0%, #ffffff 100%);
        border: 2px solid #ffffff;
        box-sizing: border-box;
        box-shadow: 24px 40px 120px rgba(0, 8, 44, 0.32);
        border-radius: 12px;
        padding: 32px 56px;
        min-width: 1200px;
        max-height: 90vh;
        padding-right: 0px;

        &__form-wrapper {
            max-height: 80vh;
            overflow-y: auto;
            padding-right: 56px;
            display: flex;
            flex-direction: column;
            row-gap: 20px;

            &::-webkit-scrollbar {
                width: 12px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #b5b8bd;
                border-radius: 30px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #b5b8bd;
            }

            &::-webkit-scrollbar-track {
                background: #ffffff;
                border: 0.8px solid #dce4ee;
                border-radius: 30px;
                box-shadow: inset 0px 0px 0px 0px #f0f0f0;
            }
        }

        &__exit-btn {
            border: 0px;
            background-color: transparent;
            position: relative;
            right: calc(-100% + 48px);
        }

        &__title {
            font-weight: 600;
            font-size: 28px;
            color: #00082c;

            &--small {
                font-size: 20px;
            }
        }

        &__top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid #dde0e7;
            padding-top: 10px;
        }

        &__row {
            display: flex;
            justify-content: space-between;
        }

        &__row-single {
            display: flex;
            justify-content: space-between;
        }

        &__col {
            display: flex;
            flex-direction: column;
            margin-bottom: 5px;

            &:nth-child(1) {
                margin-right: 24px;
            }
        }

        &__col-duo {
            display: flex;
        }

        &__col-single {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
        }

        &__label {
            font-weight: 500;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;
            margin-bottom: 8px;

            &--checkbox {
                font-weight: normal;
                font-size: 16px;
                line-height: 144%;
                color: #333956;
                margin-left: 12px;
                margin-bottom: 0px;
                padding-left: 24px;
                z-index: 6;
                cursor: pointer;
            }
        }

        &__input-text {
            margin-bottom: 10px;
            padding: 12.5px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            width: 100%;
            font-size: 16px;
            line-height: 144%;
            color: #00082c;
            min-width: 238px;

            &:focus {
                border: 1px solid #00082c;
            }

            &--small {
                min-width: 107px;
                margin-top: 7px;
            }
        }

        &__col-double {
            &__label {
                font-weight: 500;
                font-size: 14px;
                line-height: 145%;
                color: #00082c;
                margin-bottom: 8px;
            }

            &:nth-child(1) {
                margin-right: 24px;
            }
        }

        &__inputs, &__groups {
            display: flex;
            flex-direction: column;
            row-gap: 20px;
        }

        &__checkbox {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        &__check-icon {
            width: 0px;
            height: 24px;
            position: relative;
            opacity: 1;

            &:checked ~ .checkbox-mark {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &:checked ~ .add-contact-form__label--checkbox {
                padding-left: 0px;
            }

            &:before {
                content: "";
                background: #ffffff;
                border: 1px solid #d1d6df;
                box-sizing: border-box;
                box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
                border-radius: 4px;
                width: 24px;
                height: 24px;
                position: relative;
                display: block;
                top: 0px;
                left: 0px;
                opacity: 1;
            }
        }

        &__bottom-btns {
            clear: both;
            border-top: 1px solid #dde0e7;
            padding: 15px 0px;
            display: flex;
            flex-direction: row-reverse;
            column-gap: 20px;
        }

        &__action-btn {
            padding: 18px 40px 17px;
            border-radius: 4px;
            font-weight: 500;
            font-size: 16px;
            min-width: 238px;
            border: 1px solid #bbc2ce;
            background-color: transparent;
            transition: all 0.2s ease-in-out;
            float: right;


            &:hover {
                background-color: #e8ebef;
            }

            &--red {
                border: 0px;
                background: #d80418;
                color: white;
                transition: all 0.2s ease-in-out;

                &:hover {
                    background-color: #ad0313;
                }
            }
        }
    }

.import-from-db {
    display: flex;    
}

.checkbox-mark {
    background: #00082c;
    border: 1px solid #00082c;
    box-sizing: border-box;
    box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
    border-radius: 4px;
    width: 24px;
    height: 24px;
    position: relative;
    z-index: 99;
    display: none;
    top: 0px;
    left: 0px;
    opacity: 1;
}
</style>
